<section class="why-choose-us">
  <div class="container">
    <div class="why-choose-content">
      <!-- Título principal -->
      <div class="section-header">
        <h1>¿Por qué elegirnos?</h1>
        <p class="section-subtitle">Descubre un paraíso único y beneficios</p>
      </div>
      
      <!-- Tarjetas de beneficios -->
      <div class="benefits-grid">
        <div class="benefit-card" *ngFor="let benefit of benefits">
          <div class="benefit-icon">
            <img [src]="benefit.icon" [alt]="benefit.title">
          </div>
          <div class="benefit-content">
            <h3>{{ benefit.title }}</h3>
            <p>{{ benefit.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
